module.exports = __webpack_public_path__ + "static/media/app-default.71bfa012.png";